import { useGLTF, Text } from '@react-three/drei'
import * as THREE from 'three'
import { useEffect, useState } from 'react'
import BillboardHoarding from '../BillboardHoarding'

const PokemonBadges = () => {
  const gltf = useGLTF('./libs/pokemon_masters_cap/scene.gltf')
  const [githubStats, setGithubStats] = useState('')

  const model = {
    position: new THREE.Vector3(-20, 0, 10),
    rotation: new THREE.Vector3(0, Math.PI, 0),
    options: {
      focusOnPosition: new THREE.Vector3(-1, 0.8, 1),
      animateToPosition: new THREE.Vector3(0, 2.4, 5),
      fov: 20,
    },
  }

  // Api data handlers...

  const setGithubStatsHandler = (data) => {
    const githubStat = `
    Github@kartikmandhan\n
    Repos: ${data.public_repos}
    Followers: ${data.followers}
    Location: ${data.location}
    `
    setGithubStats(githubStat)
  }

  useEffect(() => {
    // Github api calls...
    fetch('https://api.github.com/users/kartikmandhan')
      .then((res) => res.json())
      .then((json) => setGithubStatsHandler(json))
  }, [])

  return (
    <mesh>
      <mesh position={[...model.position]} rotation={[...model.rotation]}>
        <boxBufferGeometry args={[1.6, 0.5, 1.6]} />
        <meshStandardMaterial color="white" />
      </mesh>
      <primitive
        position={[model.position.x, 0.3, model.position.z]}
        rotation={[0, -Math.PI / 4, 0]}
        scale={0.0005}
        object={gltf.scene}
        dispose={null}
      />
      <BillboardHoarding
        position={[model.position.x - 2, 0, model.position.z - 3]}
        scale={0.2}
        rotation={[...model.rotation]}
      />
      <Text
        color="#212121"
        position={[model.position.x - 2, 1.5, model.position.z - 3.3]}
        fontSize={0.2}
        letterSpacing={0.2}
        fillOpacity={0}
        outlineColor="#212121"
        outlineWidth={0.01}
        rotation={[...model.rotation]}
      >
        Stats
      </Text>
      <Text
        color="red"
        position={[model.position.x + 0.2, 1.5, model.position.z + 3.3]}
        fontSize={0.2}
        letterSpacing={0.2}
        fillOpacity={0}
        outlineColor="#111"
        outlineWidth={0.01}
        rotation={[...model.rotation]}
      >
        {githubStats}
      </Text>
    </mesh>
  )
}

export default PokemonBadges
